<template>
  <div class="height1" style="width: 100%;background: #F5F5F5;"> 
    <div class="topBox">
      <div><i class="el-icon-s-custom"></i>{{userInfo.name}}</div>
      <div @click="goOut">退出账号</div>
    </div>
    <div class="topBoxChos">
      <div @click="changeDetails(0)" :class="changeTable == 0 ? 'tagCheck' : 'tagCheckNo'">已支付</div>
      <div @click="changeDetails(1)" style="border-left: none; border-right: none;" :class="changeTable == 1 ? 'tagCheck' : 'tagCheckNo'">待发货</div>
      <div @click="changeDetails(2)" :class="changeTable == 2 ? 'tagCheck' : 'tagCheckNo'">待取药</div>
    </div>
      <div class="infinite-list" 
       style="overflow:auto;height:80vh">
        <div v-infinite-scroll="tableDataLoad" 
          infinite-scroll-disabled="loading"
          infinite-scroll-distance="20"
          infinite-scroll-immediate-check="false">
          <div v-for="(item,index) in tableData" :key="index" class="infinite-list-item topBoxList" @click="toOrderInfo(item)">
            <div style="color: #333333;font-weight: bold;font-size: 20px;" class="flexlr">
              <div>{{item.patientName}},<span style="margin: 0 10px">{{item.patientSex ? '男,' : '女,'}}</span>{{item.patientAge}}</div>
              <span v-if="changeTable == 0" style="font-weight: 400;font-size: 20px;color: #3F7EE9">已支付</span>
              <span v-if="changeTable == 1" style="font-weight: 400;font-size: 20px;color: #3F7EE9">待发货</span>
              <span v-if="changeTable == 2" style="font-weight: 400;font-size: 20px;color: #3F7EE9">待取药</span>
            </div>
            <div style="color: #333333;"><span>诊断：</span>{{item.diagnoseResult}}</div>
            <div><span>就诊日期：</span>{{item.paySuccessTime | timefilters}}</div>
            <div><span>开方医生：</span>{{item.doctorName}} <span style="margin-left:10px">{{item.doctorPhone}}</span> </div>
            <div><span>订单编号：</span>{{item.orderNum}}</div>
          </div>
            <div v-if="loading" class="loading-text" style="text-align: center; padding: 10px;">
              加载中...
            </div>
            <div v-if="noMoreData" class="loading-text" style="text-align: center; padding: 10px;">
              没有更多数据了
            </div>
          </div>
      </div>
    <el-dialog title="签名" :visible.sync="esigndialogVisible" width="30%" :close-on-click-modal="false">
      <vue-esign style="border: 1px solid #ddd; height: 200px" ref="esign" :isCrop="isCrop" :width="600" :height="200" :lineWidth="lineWidth" :lineColor="lineColor" :bgColor.sync="bgColor"></vue-esign>
      <div class="flex-space-between" style="margin-top: 20px">
        <div class="flex-center" v-if="UserSignImg">
          <el-checkbox v-model="useLast">使用上次签名 </el-checkbox>
          <img style="width: 100px; height: 40px" :src="CommonPath + UserSignImg" alt="" srcset="" />
        </div>
        <div v-else></div>
        <span>
          <el-button @click="handleReset">清空签名</el-button>
          <el-button @click="esigndialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleGenerate">确 定</el-button>
        </span>
      </div>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="logoutDialogVisible"
      width="80%"
        >
      <span>此操作将注销登录, 是否继续?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="logoutDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="gologout">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Outpatient } from '@/components/DrugDomain/Outpatient.js'
import { Order } from '@/components/HospitalDomain/ShopMall/Order'
import { Organization } from '@/components/HospitalDomain/Organization'
import axios from 'axios'
export default {
  data() {
    var outpatient = new Outpatient(this.TokenClient, this.Services.Drug)
    var order = new Order(this.TokenClient, this.Services.Shopping)
    var organizationer = new Organization(this.TokenClient, this.Services.Authorization)
    return {
      OutpatientDomain: outpatient,
      OrganizationDomain: organizationer,
      OrderDomain: order,
      headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' },
      userInfo: JSON.parse(sessionStorage.getItem('userInfo')),
      tableData: [],
      pageIndex: 1,
      dataTotal: 1,
      pageCount:1,
      pageSize: 0,
      setDialog: false,
       count: 0,
      changeTable:0,
      searchForm: {
        keyWord: this.$route.query.orderNum ? this.$route.query.orderNum : '',
        datepicker: '',
      },
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
      },
      statusOption: [
        {
          value: '',
          label: '全部',
        },
        {
          value: '0',
          label: '待付款',
        },
        {
          value: '2',
          label: '待发货',
        },
        {
          value: '3',
          label: '已发货',
        },
        {
          value: '1',
          label: '已完成',
        },
        {
          value: '-999',
          label: '退单',
        },
        {
          value: '-1',
          label: '已取消',
        },
        {
          value: '-2',
          label: '已删除',
        },
      ],
      title: '余额明细',
      DataCount: 0,
      json_fields: {
        订单编号: {
          filed: 'key',
          callback: (val) => {
            return 'NO：' + val.key
          },
        },
        当前余额: 'name',
      },
      fileList: [],
      setDeliveryDialog: false,
      formDelivery: {
        mzOrderId: 0,
        expressCompany: '',
        expressCode: '',
      },
      dialogExpress: false,
      expressData: {
        number: '432578454379043', //快递单号
        type: 'YUNDA', //快递公司简称
        deliverystatus: '3', //快递状态 0快递收件 (揽件)1.在途中 2.正在派件 3.已签收 4.派送失败 5.疑难件 6.退件签收
        issign: '1', //是否签收 可能不准
        expName: '韵达快递', //快递公司名称
        expSite: 'www.yundaex.com', //快递公司官网
        expPhone: '95546', //快递公司电话
        courier: '', //投递员名称
        courierPhone: '0371-61844349', // 快递员电话
        updateTime: '2022-05-31T19:20:26', //快递轨迹信息最新时间
        takeTime: '1天21小时19分', //发货到收货消耗时长 (截止最新轨迹)
        logo: 'https://img3.fegine.com/express/yd.jpg', //快递公司LOGO
        list: [
          //快递详情
          {
            time: '2022-05-31T19:20:26',
            status: '【代收点】您的快件已签收，签收人在 郑州兴达锦绣园新街坊超市店(已签收签收人凭取货码签收) 领取，投诉电话: 0371 - 61844349',
          },
        ],
      },
      direction: 'rtl',
      rules: {
        expressCompany: [{ required: true, message: '请输入快递公司', trigger: 'blur' }],
        expressCode: [{ required: true, message: '请输入快递单号', trigger: 'blur' }],
      },
      FileUploadUrl: this.CommonFilePath,
      esigndialogVisible: false,
      orderId: 0,
      lineWidth: 6, //画笔粗细
      lineColor: '#000000', //画笔颜色
      bgColor: '', //画布背景色，为空时画布背景透明
      imgurl: '', //签名生成的图片
      isCrop: false, //是否裁剪，在画布设定尺寸基础上裁掉四周空白部分
      UserSignImg: '',
      useLast: false,
      orgInfo: {},
       loading: false,// 加载状态（防止重复请求）
      noMoreData: false, // 是否还有更多数据
      stateDetail:1,
      isSelef:-1,
      logoutDialogVisible:false
    }
  },
  mounted() {
    this.pageIndex = 1
    this.tableData = []
    this.getOrgInfo()
    this.getList()
  },
  methods: {
    gologout(){
        window.sessionStorage.clear();
        this.$message.success("已退出");
        this.logoutDialogVisible = false
        this.$router.push("/phoneLogin");
        //触发后禁止浏览器的后退键
        history.pushState(null, null, document.URL);
        window.addEventListener(
          "popstate",
          function (e) {
            history.pushState(null, null, document.URL);
          },
          false
        );
    },
    goOut(){
      this.logoutDialogVisible = true
      // this.$confirm("此操作将注销登录, 是否继续?", "提示", {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     type: "warning",
      //   })
      //     .then(() => {
      //       window.sessionStorage.clear();
      //       this.$message.success("已退出");
      //       this.$router.push("/phoneLogin");
      //       //触发后禁止浏览器的后退键
      //       history.pushState(null, null, document.URL);
      //       window.addEventListener(
      //         "popstate",
      //         function (e) {
      //           history.pushState(null, null, document.URL);
      //         },
      //         false
      //       );
      //       // this.getRequest("/logout");
      //     })
      //     .catch(() => {
      //       this.$message({
      //         type: "info",
      //         message: "已取消操作",
      //       });
      //     });
    },
      tableDataLoad(){
          if (this.pageIndex < this.pageCount) {
              setTimeout(() => {
                  this.pageIndex++
                  this.getList();//执行的方法
              }, 2000)
          } else { //停止加载
              this.noMoreData = true;
          }
      },
    getOrgInfo() {
      var _this = this;
      _this.OrganizationDomain.GetOrgInfo(
        function (data) {
          _this.orgInfo = data.data.organization;
        },
        function (err) {
          console.log(err);
        }
      );
    },
    handleReset() {
      if (this.$refs.esign) {
        this.$refs.esign.reset()
      }
    },
    getAuditSignImg() {
      var _this = this
      _this.OrganizationDomain.GetUserSign(
        function (data) {
          _this.UserSignImg = data.data
          _this.esigndialogVisible = true
        },
        function (error) {
          _this.esigndialogVisible = true
          // let jsonObj = JSON.parse(error.msg)
          // _this.$message({
          //   message: jsonObj.msg,
          //   type: 'error',
          // })
          console.log(error)
        }
      )
    },
    handleGenerate() {
      let _this = this
      if (_this.useLast) {
        _this.auditSignImg = _this.UserSignImg
        _this.setAuditSignImg()
      } else {
        _this.$refs.esign
          .generate()
          .then((res) => {
            // 转成文件
            var blob = _this.dataURLtoBlob(res)
            var tofile = _this.blobToFile(blob, '签名.jpg')
            const formData = new FormData()
            setTimeout(async () => {
              formData.append('file', tofile, tofile.name)
              // formData.append('fileType', 9)
              // ajax 请求
              axios({
                method: 'POST',
                headers: { 'Content-Type': 'multipart/form-data', Authorization: 'Bearer' + ' ' + JSON.parse(sessionStorage.getItem(this.ClientId + 'Token')).access_token },
                // 这里是你的上传地址
                url: _this.FileUploadUrl,
                data: formData,
              })
                .then((res) => {
                  _this.auditSignImg = res.data[0].completeFilePath
                  _this.setAuditSignImg()
                })
                .catch((err) => {
                  _this.$message.error('上传签名失败')
                })
            })
          })
          .catch((err) => {
            _this.$message.error('请签名之后提交！')
          })
      }
    },
    setAuditSignImg() {
      var _this = this
      _this.OrganizationDomain.SetUserSign(
        this.auditSignImg,
        function (data) {
          _this.handleReset()
          _this.esigndialogVisible = false
          _this.saveCompleteDrug()
        },
        function (error) {
          let jsonObj = JSON.parse(error.msg)
          _this.$message({
            message: jsonObj.msg,
            type: 'error',
          })
          console.log(error)
        }
      )
    },
    // 将base64转换为blob
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    // 将blob转换为file
    blobToFile(theBlob, fileName) {
      theBlob.lastModifiedDate = new Date()
      theBlob.name = fileName
      return theBlob
    },
    saveDelivery(formName) {
      var _this = this
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          // if (_this.formDelivery.expressCode.toLowerCase().includes('sf')) {
            let code = _this.formDelivery.expressCode
            let str = _this.formDelivery.takeAddress.split(',')[1]
            if (_this.formDelivery.expressCode.includes(':') || _this.formDelivery.expressCode.includes('：')) {
              code = code.split(':')[0]
            }
            if (str) {
              _this.formDelivery.expressCode = code + ':' + str.substring(str.length - 4)
            }
          // }
          _this.OutpatientDomain.MZDeliverGoods(
            _this.formDelivery,
            function (data) {
              _this.$message({
                message: '发货成功',
                type: 'success',
              })
              _this.setDeliveryDialog = false
              _this.getList()
            },
            function (error) {
              let jsonObj = JSON.parse(error.msg)
              _this.$message({
                message: jsonObj.msg,
                type: 'error',
              })
              console.log(error)
            }
          )
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    /**
     * 查看物流
     * @param {*} item
     */
    showExpress(item) {
      var _this = this
      _this.expressData = {}
      var expressCodeStr = item.expressCode
      if (expressCodeStr) {
        _this.dialogExpress = true
        _this.OrderDomain.ExpressQuery(
          expressCodeStr,
          function (data) {
            _this.dialogExpress = true
            _this.expressData = data.data
          },
          function (err) {
            _this.$message({
              type: 'error',
              message: '快递单号错误',
            })
            console.log(err)
          }
        )
      } else {
        _this.$message({
          type: 'error',
          message: '单号无效',
        })
      }
    },
    CloseDelivery(formName) {
      this.setDeliveryDialog = false
      this.$refs[formName].resetFields()
    },
    AddDelivery(item) {
      this.setDeliveryDialog = true
      this.formDelivery.mzOrderId = item.id
      this.formDelivery.expressCompany = ''
      this.formDelivery.takeAddress = item.takeAddress
      this.formDelivery.expressCode = item.expressCode ? item.expressCode : ''
    },
    toComplete(item) {
      var _this = this
      _this
        .$confirm('是否完成取药?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          // type: 'warning'
        })
        .then(() => {
          let map = {
            mzOrderId: item.id,
          }
          _this.OutpatientDomain.MZConfirmReceipt(
            map,
            function (data) {
              _this.$message({
                message: '完成取药成功',
                type: 'success',
              })
              _this.getList()
            },
            function (error) {
              let jsonObj = JSON.parse(error.msg)
              _this.$message({
                message: jsonObj.msg,
                type: 'error',
              })
              console.log(error)
            }
          )
        })
        .catch(() => {})
    },
    toCompleteDrug(item) {
      var _this = this
      _this
        .$confirm('完成备药?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          // type: 'warning'
        })
        .then(() => {
          _this.orderId = item.id
          _this.getAuditSignImg()
        })
        .catch(() => {})
    },
    saveCompleteDrug() {
      var _this = this
      _this.OutpatientDomain.DrugCompleteOrg(
        this.orderId,
        this.auditSignImg,
        function (data) {
          _this.$message({
            message: '完成备药成功',
            type: 'success',
          })
          _this.getList()
        },
        function (error) {
          let jsonObj = JSON.parse(error.msg)
          _this.$message({
            message: jsonObj.msg,
            type: 'error',
          })
          console.log(error)
        }
      )
    },
    toOrderInfo(item) {
      this.$router.push({
        path: './OrderInfoPhone',
        query: {
          type: 1, //已收费
          orderId: item.id,
        },
      })
    },
    changeDetails(e) {
      if (e == 0) {
        this.changeTable = e
        this.stateDetail = 1
        this.isSelef = -1
        this.pageIndex = 1
        this.tableData = []
        this.getList()
      }
      if (e == 1) {
        this.changeTable = e
        this.stateDetail = 3
        this.isSelef = 0
        this.pageIndex = 1
        this.tableData = []
        this.getList()
      }
      if (e == 2) {
        this.changeTable = e
        this.stateDetail = 3
        this.isSelef = 1
        this.pageIndex = 1
        this.tableData = []
        this.getList()
      }
    },
    getList() {
      var _this = this
      _this.loading = true;
      var item = _this.searchForm
      if (_this.searchForm.datepicker) {
        item.startTime = _this.searchForm.datepicker[0] + ' 00:00:00'
        item.endTime = _this.searchForm.datepicker[1] + ' 23:59:59'
      } else {
        item.startTime = ''
        item.endTime = ''
      }
      let param = true + '/' + _this.stateDetail + '/' + _this.isSelef
      _this.OutpatientDomain.DrugAlreadyPayment(
        item.keyWord,
        item.startTime,
        item.endTime,
        _this.pageIndex,
        param,
        function (data) {
          const dataMap = data.data.results;
          _this.tableData = _this.reload ? dataMap : _this.tableData.concat(dataMap);
          _this.pageIndex = data.data.pageIndex
          _this.pageSize = data.data.pageSize
          _this.pageCount = data.data.pageCount
          _this.dataTotal = data.data.dataTotal
           _this.loading = false;
        },
        function (err) {
          console.log(err)
        }
      )
    },
    Search(event) {
      this.pageIndex = 1
      this.tableData = []
      this.getList()
    },
    // 导入数据
    handleExcel(file, fileList) {
      console.log(file.raw)
      let formData = new FormData() //声明一个FormDate对象
      formData.append('formFile', file.raw) //把文件信息放入对象中
    },
    //模板下载
    downloadTemplate() {
      let a = document.createElement('a')
      a.href = './drug_import_template_with_branch.xls'
      a.download = '药品模板.xlsx'
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
      a.remove()
    },
    async fetchData() {
      var _this = this
      return await _this.getAllData()
    },
    getAllData() {
      var _this = this
      return new Promise((resolve, reject) => {
        // var item = _this.searchForm;
        // if (_this.searchForm.datepicker) {
        //   item.startTime = _this.searchForm.datepicker[0] + " 00:00:00";
        //   item.endTime = _this.searchForm.datepicker[1] + " 23:59:59";
        // } else {
        //   item.startTime = "";
        //   item.endTime = "";
        // }
        // _this.BalanceDomain.BalanceDetail(
        //   item.startTime,
        //   item.endTime,
        //   item.keyWord,
        //   item.state,
        //   1,
        //   _this.DataCount,
        //   function (data) {
        //     resolve(data.data.results);
        //   },
        //   function (err) {
        resolve('')
        //     console.log(err);
        //   }
        // );
      })
    },
  },
}
</script>

<style scoped>

.topBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #3F7EE9;
  font-size: 18px;
  color: #FFFFFF;
  padding: 20px 25px;

}
.topBoxChos {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  background: #FFFFFF;
}
.tagCheck {
  background: #3F7EE9;
  border: 1px solid #3F7EE9;
  width: 33.3%;
  font-size: 18px;
  color: #FEFEFE;
  text-align: center;
   padding: 10px 0;
}
.tagCheckNo {
  background: #FFFFFF;
  border: 1px solid #CCCCCC;
  width: 33.3%;
  font-size: 18px;
  text-align: center;
  padding: 10px 0;
}
.topBoxList {
  background: #FAFAFA;
  border-radius: 12px;
  font-size: 18px;
  color: #999999;
  margin: 20px;
  padding: 20px 15px;
}
.detail-item {
  position: relative;
  margin-bottom: 20px;
}

.detail-item .detail-tit {
  font-size: 18px;
}

.detail-item > p {
  margin: 5px 0;
}

.detail-item > p span {
  display: inline-block;
  width: 100px;
  text-align: right;
}

.detail-item .status {
  position: absolute;
  right: 5px;
  top: 5px;
}

.detail-item .status .text-orange {
  color: orange;
}

.detail-item .status .text-blue {
  color: rgb(47, 0, 255);
}

.detail-item .status p.text-danger {
  color: red;
}

.detail-item .status p.text-succes {
  color: forestgreen;
}
.flexlr {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
